/**
 * EVRLIGHT — Premium Visual Animations
 * Runs as a standard script (non-module) so it loads without import map.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  /* ═══════════════════════════════════════════════════════════
     1. SCROLL FADE-IN / SLIDE-UP
     Marks product cards, collection cards, and section blocks
     with [data-animate], then reveals them via IntersectionObserver.
     Grid parents get [data-animate-stagger] for cascading delays.
  ═══════════════════════════════════════════════════════════ */

  function initScrollFade() {
    if (reducedMotion) return;

    /* ── Elemente die EINZELN animieren ── */
    var ITEM_SELECTORS = [
      /* Karten / Grid-Kinder */
      '.product-grid__card',
      '.collection-card',
      '.resource-card',
      '.featured-collection-block',
      '.blog-post-card',
      '.blog-post-item',
      '.collection-links__item',
      /* Listen-Zeilen */
      '.resource-list__item',
      /* Sektions-Text-Blöcke */
      '.shopify-section .section__header',
      '.shopify-section .hero__content',
      '.shopify-section .media-with-content__content',
      '.shopify-section .marquee',
      /* Produktseite */
      '.product-information__media',
      '.product-information__details',
      /* Featured product */
      '.featured-product .section-content-wrapper',
      /* Image / Media Blocks */
      '.image-block',
      '.media-block',
      /* Vers des Tages */
      '.verse-of-day__inner',
      /* Footer */
      '.footer-utilities__group-copyright',
      '.footer-nav-block',
    ].join(',');

    /* ── Eltern-Container die Stagger auslösen ── */
    var STAGGER_SELECTORS = [
      '.product-grid',
      '.collection-list__grid',
      '.featured-blog-posts__grid',
      '.collection-links__container',
      '.blog-posts-container',
      '.product-recommendations .section-resource-list__content',
    ].join(',');

    /* ── Elemente die als ganzes (nicht als Kind) staggern ── */
    var STAGGER_CHILD_SELECTORS = [
      /* Footer-Spalten nebeneinander */
      '.footer-section__column',
      /* Kollektion-Kacheln in collection-list */
      '.collection-list__grid > *',
    ].join(',');

    function mark(scope) {
      scope = scope || document;

      /* Stagger-Wrapper markieren */
      scope.querySelectorAll(STAGGER_SELECTORS).forEach(function (el) {
        if (!el.hasAttribute('data-animate-stagger')) {
          el.setAttribute('data-animate-stagger', '');
        }
      });

      /* Alle Einzel-Elemente */
      scope.querySelectorAll(ITEM_SELECTORS).forEach(function (el) {
        /* Nicht doppelt markieren, nicht bereits sichtbare */
        if (!el.hasAttribute('data-animate') && !el.classList.contains('is-visible')) {
          el.setAttribute('data-animate', '');
        }
      });

      /* Stagger-Kinder, die noch kein data-animate vom Eltern-Stagger haben */
      scope.querySelectorAll(STAGGER_CHILD_SELECTORS).forEach(function (el) {
        if (!el.hasAttribute('data-animate') && !el.classList.contains('is-visible')) {
          el.setAttribute('data-animate', '');
          /* Elternteil als Stagger-Container markieren, falls noch nicht */
          if (el.parentElement && !el.parentElement.hasAttribute('data-animate-stagger')) {
            el.parentElement.setAttribute('data-animate-stagger', '');
          }
        }
      });

      /* ── Direktionale Richtungsattribute setzen ── */
      /* Sektions-Header: von links */
      scope.querySelectorAll('.section__header, .media-with-content__content').forEach(function (el) {
        if (!el.getAttribute('data-animate-dir')) {
          el.setAttribute('data-animate-dir', 'left');
        }
      });

      /* Bilder / Medien: von rechts */
      scope.querySelectorAll('.media-with-content__media, .image-block, .media-block').forEach(function (el) {
        if (!el.getAttribute('data-animate-dir')) {
          el.setAttribute('data-animate-dir', 'right');
        }
      });

      /* Produktkarten: Spring-Scale */
      scope.querySelectorAll('.product-grid__card').forEach(function (el) {
        if (!el.getAttribute('data-animate-dir')) {
          el.setAttribute('data-animate-dir', 'product');
        }
      });
    }

    function createObserver() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-animate]').forEach(function (el) {
          el.classList.add('is-visible');
        });
        return null;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var el = entry.target;
              /* will-change kurz vor Reveal setzen → nur das animierende Element promoted */
              el.style.willChange = 'opacity, transform';
              el.classList.add('is-visible');
              observer.unobserve(el);
              /* will-change nach Transition-Ende freigeben */
              el.addEventListener('transitionend', function cleanup() {
                el.style.willChange = 'auto';
                el.removeEventListener('transitionend', cleanup);
              }, { once: true });
            }
          });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0.04 }
      );

      function observeAll() {
        document.querySelectorAll('[data-animate]:not(.is-visible)').forEach(function (el) {
          observer.observe(el);
        });
      }

      observeAll();
      return { observer: observer, observeAll: observeAll };
    }

    mark();
    var obs = createObserver();

    /* Re-scan nach Shopify-Sektions-Updates (Filter, Quick Add, etc.) */
    document.addEventListener('shopify:section:load', function (e) {
      mark(e.target);
      if (obs) { obs.observeAll(); }
    });

    /* Re-scan nach AJAX-Navigation (Kollektion-Filter etc.) */
    document.addEventListener('page:load', function () {
      mark();
      if (obs) { obs.observeAll(); }
    });
  }


  /* ═══════════════════════════════════════════════════════════
     2. MAGNETIC BUTTONS
     Only active on devices with a fine pointer (mouse).
     Buttons move max 9px toward the cursor, spring back on leave.
     Uses lerp + rAF for smooth motion.
  ═══════════════════════════════════════════════════════════ */

  function initMagneticButtons() {
    // Require fine pointer (mouse) AND no reduced-motion preference
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (reducedMotion) return;

    var SELECTOR = [
      '.button:not(.button-unstyled)',
      '.button-secondary',
      '[data-magnetic]',
    ].join(',');

    var MAX_MOVE = 9; // px
    var LERP_FACTOR = 0.13;
    var SNAP_THRESHOLD = 0.08; // px — stop rAF below this

    function attachMagnet(btn) {
      var targetX = 0, targetY = 0;
      var currentX = 0, currentY = 0;
      var rafId = null;
      var isHovered = false;

      function lerp(a, b, t) { return a + (b - a) * t; }

      function tick() {
        currentX = lerp(currentX, targetX, LERP_FACTOR);
        currentY = lerp(currentY, targetY, LERP_FACTOR);

        btn.style.transform = 'translate(' + currentX.toFixed(2) + 'px, ' + currentY.toFixed(2) + 'px)';

        var stillMoving =
          Math.abs(targetX - currentX) > SNAP_THRESHOLD ||
          Math.abs(targetY - currentY) > SNAP_THRESHOLD;

        if (stillMoving) {
          rafId = requestAnimationFrame(tick);
        } else {
          // Snap cleanly to 0 when resting at origin after leave
          if (!isHovered) {
            btn.style.transform = '';
            currentX = 0;
            currentY = 0;
          }
          rafId = null;
        }
      }

      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var cx = rect.left + rect.width * 0.5;
        var cy = rect.top + rect.height * 0.5;
        var dx = (e.clientX - cx) / (rect.width * 0.5);
        var dy = (e.clientY - cy) / (rect.height * 0.5);

        // Clamp to [-1, 1] so corners don't over-extend
        dx = Math.max(-1, Math.min(1, dx));
        dy = Math.max(-1, Math.min(1, dy));

        targetX = dx * MAX_MOVE;
        targetY = dy * MAX_MOVE;

        if (!rafId) rafId = requestAnimationFrame(tick);
      });

      btn.addEventListener('mouseenter', function () {
        isHovered = true;
      });

      btn.addEventListener('mouseleave', function () {
        isHovered = false;
        targetX = 0;
        targetY = 0;
        if (!rafId) rafId = requestAnimationFrame(tick);
      });
    }

    function setup() {
      document.querySelectorAll(SELECTOR).forEach(function (btn) {
        // Avoid attaching twice
        if (btn.dataset.magneticAttached) return;
        btn.dataset.magneticAttached = '1';
        attachMagnet(btn);
      });
    }

    document.addEventListener('DOMContentLoaded', setup);
    document.addEventListener('shopify:section:load', setup);
  }


  /* ═══════════════════════════════════════════════════════════
     3. TEXT REVEAL ANIMATION
     Targets elements with [data-text-reveal].
     Splits text into words, each wrapped in a span with a staggered
     CSS custom property delay, then revealed via IntersectionObserver.
  ═══════════════════════════════════════════════════════════ */

  function initTextReveal() {
    // Auto-mark large headings in hero/slideshow areas, plus any manual [data-text-reveal]
    var AUTO_SELECTORS = [
      '.hero__content-wrapper h1',
      '.hero__content-wrapper h2',
      '.slideshow__slide h1',
      '.slideshow__slide h2',
      '.jumbo-text',
      '.media-with-content__content h1',
      '.media-with-content__content h2',
    ].join(',');

    document.querySelectorAll(AUTO_SELECTORS).forEach(function (el) {
      if (!el.hasAttribute('data-text-reveal')) {
        el.setAttribute('data-text-reveal', '');
      }
    });

    var SELECTOR = '[data-text-reveal]';
    var isMobile = window.innerWidth < 750;

    // Base delay per word: slightly faster on mobile
    var WORD_DELAY_DESKTOP = 0.07; // seconds
    var WORD_DELAY_MOBILE = 0.05;

    function splitWords(el) {
      // Guard: already split
      if (el.querySelector('.text-reveal-word')) return;

      var baseDelay = isMobile ? WORD_DELAY_MOBILE : WORD_DELAY_DESKTOP;
      var words = el.textContent.trim().split(/\s+/);

      el.innerHTML = words.map(function (word, i) {
        var delay = (i * baseDelay).toFixed(2);
        return '<span class="text-reveal-word" style="--word-delay:' + delay + 's">' + word + '</span>';
      }).join(' ');
    }

    function revealEl(el) {
      el.querySelectorAll('.text-reveal-word').forEach(function (span) {
        span.classList.add('is-visible');
      });
    }

    function observe() {
      var els = document.querySelectorAll(SELECTOR);
      if (!els.length) return;

      // If reduced motion: skip splitting, CSS shows words immediately
      if (reducedMotion) {
        els.forEach(function (el) { el.style.visibility = 'visible'; });
        return;
      }

      els.forEach(splitWords);

      if (!('IntersectionObserver' in window)) {
        els.forEach(revealEl);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealEl(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0.1 }
      );

      els.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  }


  /* ═══════════════════════════════════════════════════════════
     4. VERSE OF THE DAY
     Picks a verse by day-of-year (same verse for all visitors
     on the same calendar day). Fades in with glow on scroll-into-view.
  ═══════════════════════════════════════════════════════════ */

  function initVerseOfDay() {
    var container = document.getElementById('verse-of-day');
    if (!container) return;

    /* Verse list — source: assets/evrlight-verses.json (English, public domain wording) */
    var VERSES = [
      { text: 'I can do all things through Christ who strengthens me.', ref: 'Phil 4:13' },
      { text: 'The LORD is my light and my salvation; whom shall I fear?', ref: 'Ps 27:1' },
      { text: 'Take heart! I have overcome the world.', ref: 'John 16:33' },
      { text: 'You are the light of the world.', ref: 'Matt 5:14' },
      { text: 'The LORD will fight for you, and you shall hold your peace.', ref: 'Ex 14:14' },
      { text: 'Believe in the Lord Jesus, and you will be saved, you and your household.', ref: 'Acts 16:31' },
      { text: 'He gives power to the faint, and to him who has no might he increases strength.', ref: 'Isa 40:29' },
      { text: 'For I know the plans I have for you: plans for peace and not for evil.', ref: 'Jer 29:11' },
      { text: 'Those who wait for the LORD will renew their strength.', ref: 'Isa 40:31' },
      { text: 'Cast all your anxiety on him, because he cares for you.', ref: '1 Pet 5:7' },
      { text: 'Do not fear, for I am with you; do not be dismayed, for I am your God.', ref: 'Isa 41:10' },
      { text: 'God is our refuge and strength, a very present help in trouble.', ref: 'Ps 46:1' },
      { text: 'Be strong and courageous. Do not be afraid; do not be discouraged.', ref: 'Josh 1:9' },
      { text: 'Peace I leave with you; my peace I give to you.', ref: 'John 14:27' },
      { text: 'The LORD will keep your going out and your coming in, from this time forth and forevermore.', ref: 'Ps 121:8' },
      { text: 'I am the light of the world. Whoever follows me will not walk in darkness.', ref: 'John 8:12' },
      { text: 'Seek first the kingdom of God and his righteousness, and all these things will be added to you.', ref: 'Matt 6:33' },
      { text: 'Be strong, and do not let your hands be weak, for your work shall be rewarded.', ref: '2 Chr 15:7' },
      { text: 'For we walk by faith, not by sight.', ref: '2 Cor 5:7' },
      { text: 'The LORD is my shepherd; I shall not want.', ref: 'Ps 23:1' },
      { text: 'For by grace you have been saved through faith.', ref: 'Eph 2:8' },
      { text: 'Do not fear, for I have redeemed you; I have called you by name; you are mine.', ref: 'Isa 43:1' },
      { text: 'Love never fails.', ref: '1 Cor 13:8' },
      { text: 'I am the resurrection and the life.', ref: 'John 11:25' },
      { text: 'All authority in heaven and on earth has been given to me.', ref: 'Matt 28:18' },
      { text: 'Now to him who is able to do far more than all we ask or think, be glory.', ref: 'Eph 3:20' },
      { text: 'Know that the LORD is God. It is he who made us, and we are his.', ref: 'Ps 100:3' },
      { text: 'In the fear of the LORD is strong confidence.', ref: 'Prov 14:26' },
      { text: 'God is light, and in him is no darkness at all.', ref: '1 John 1:5' },
      { text: 'Yes, I am coming soon. Amen. Come, Lord Jesus!', ref: 'Rev 22:20' },
      { text: 'We know that all things work together for good to those who love God.', ref: 'Rom 8:28' },
      { text: 'Now faith is the assurance of things hoped for, the conviction of things not seen.', ref: 'Heb 11:1' },
      { text: 'May the God of hope fill you with all joy and peace in believing.', ref: 'Rom 15:13' },
      { text: 'God did not give us a spirit of fear, but of power, love, and self-control.', ref: '2 Tim 1:7' },
      { text: 'Trust in the LORD with all your heart, and do not lean on your own understanding.', ref: 'Prov 3:5' },
      { text: 'Commit your way to the LORD; trust in him, and he will act.', ref: 'Ps 37:5' },
      { text: 'All things are possible to him who believes.', ref: 'Mark 9:23' },
      { text: 'I no longer live, but Christ lives in me.', ref: 'Gal 2:20' },
      { text: 'We love, because he first loved us.', ref: '1 John 4:19' },
      { text: 'For God so loved the world that he gave his only Son.', ref: 'John 3:16' },
      { text: 'Now faith, hope, and love remain, these three; the greatest of these is love.', ref: '1 Cor 13:13' },
      { text: 'I am convinced that neither death nor life can separate us from the love of God in Christ Jesus.', ref: 'Rom 8:38-39' },
      { text: 'I love you, LORD, my strength!', ref: 'Ps 18:1' },
      { text: 'Be strong in the Lord and in the strength of his might.', ref: 'Eph 6:10' },
      { text: 'The light shines in the darkness, and the darkness has not overcome it.', ref: 'John 1:5' },
      { text: 'Trust in the LORD forever, for the LORD is an everlasting rock.', ref: 'Isa 26:4' },
      { text: 'My grace is sufficient for you, for my power is made perfect in weakness.', ref: '2 Cor 12:9' },
      { text: 'The LORD is my strength and my shield; my heart trusts in him.', ref: 'Ps 28:7' },
      { text: 'Greater love has no one than this: to lay down one\'s life for his friends.', ref: 'John 15:13' },
      { text: 'I am not ashamed of the gospel, for it is the power of God.', ref: 'Rom 1:16' },
      { text: 'Taste and see that the LORD is good.', ref: 'Ps 34:8' },
      { text: 'Come to me, all who labor and are heavy laden, and I will give you rest.', ref: 'Matt 11:28' },
      { text: 'You, LORD, have not forsaken those who seek you.', ref: 'Ps 9:10' },
      { text: 'God shows his love for us in that while we were still sinners, Christ died for us.', ref: 'Rom 5:8' },
      { text: 'Whatever you do, work at it with all your heart, as for the Lord and not for men.', ref: 'Col 3:23' },
      { text: 'God is faithful; he will not let you be tempted beyond what you can bear.', ref: '1 Cor 10:13' },
      { text: 'My flesh and my heart may fail, but God is the strength of my heart forever.', ref: 'Ps 73:26' },
      { text: 'Jesus Christ is the same yesterday, today, and forever.', ref: 'Heb 13:8' },
      { text: 'Though the mountains be shaken, my steadfast love will not depart from you.', ref: 'Isa 54:10' },
      { text: 'Your word is a lamp to my feet and a light to my path.', ref: 'Ps 119:105' },
      { text: 'I came that they may have life, and have it abundantly.', ref: 'John 10:10' },
      { text: 'Rejoice in hope, be patient in tribulation, be constant in prayer.', ref: 'Rom 12:12' },
      { text: 'The LORD is my strength and my song, and he has become my salvation.', ref: 'Ex 15:2' },
      { text: 'My soul finds rest in God alone; my salvation comes from him.', ref: 'Ps 62:1' },
      { text: 'Let your light shine before others.', ref: 'Matt 5:16' },
      { text: 'He who is in you is greater than he who is in the world.', ref: '1 John 4:4' },
      { text: 'The name of the LORD is a strong tower; the righteous run to it and are safe.', ref: 'Prov 18:10' },
      { text: 'Be strong, and let your heart take courage, all you who hope in the LORD.', ref: 'Ps 31:24' },
      { text: 'Behold, God is my salvation; I will trust and not be afraid.', ref: 'Isa 12:2' },
      { text: 'And the peace of God, which surpasses all understanding, will guard your hearts and minds.', ref: 'Phil 4:7' },
      { text: 'He heals the brokenhearted and binds up their wounds.', ref: 'Ps 147:3' },
      { text: 'In all these things we are more than conquerors through him who loved us.', ref: 'Rom 8:37' },
      { text: 'Arise, shine, for your light has come, and the glory of the LORD has risen upon you.', ref: 'Isa 60:1' },
      { text: 'I am the vine, you are the branches. Whoever remains in me bears much fruit.', ref: 'John 15:5' },
      { text: 'The steadfast love of the LORD never ceases; his mercies are new every morning.', ref: 'Lam 3:22-23' },
      { text: 'Cast your burden on the LORD, and he will sustain you.', ref: 'Ps 55:22' },
      { text: 'With man this is impossible, but with God all things are possible.', ref: 'Matt 19:26' },
      { text: 'For freedom Christ has set us free.', ref: 'Gal 5:1' },
      { text: 'I have set the LORD always before me; he is at my right hand, I shall not be shaken.', ref: 'Ps 16:8' },
      { text: 'There is now no condemnation for those who are in Christ Jesus.', ref: 'Rom 8:1' },
      { text: 'For the LORD God is a sun and shield; the LORD gives grace and glory.', ref: 'Ps 84:11' },
      { text: 'When you pass through the waters, I will be with you; when you walk through fire, you will not be burned.', ref: 'Isa 43:2' },
      { text: 'Christ in you, the hope of glory.', ref: 'Col 1:27' },
      { text: 'I am the way, the truth, and the life.', ref: 'John 14:6' },
      { text: 'The people walking in darkness have seen a great light.', ref: 'Isa 9:2' },
      { text: 'Wait for the LORD; be strong and take heart, and wait for the LORD.', ref: 'Ps 27:14' },
      { text: 'The joy of the LORD is your strength.', ref: 'Neh 8:10' },
      { text: 'Your word is truth.', ref: 'John 17:17' },
      { text: 'The LORD is near to all who call on him, to all who call on him in truth.', ref: 'Ps 145:18' },
      { text: 'The path of the righteous is like the light of dawn.', ref: 'Prov 4:18' },
      { text: 'Blessed is the one who perseveres under trial.', ref: 'James 1:12' },
      { text: 'Seek the LORD and his strength; seek his presence continually!', ref: '1 Chr 16:11' },
      { text: 'I am confident that he who began a good work in you will bring it to completion.', ref: 'Phil 1:6' },
      { text: 'Set your minds on things above, not on earthly things.', ref: 'Col 3:2' },
      { text: 'In the day of my trouble I call on you, for you answer me.', ref: 'Ps 86:7' },
      { text: 'Do not dwell on the past. See, I am doing a new thing!', ref: 'Isa 43:18-19' },
      { text: 'Whoever dwells in the shelter of the Most High will rest in the shadow of the Almighty.', ref: 'Ps 91:1' },
      { text: 'I will give you a new heart and put a new spirit in you.', ref: 'Ezek 36:26' },
      { text: 'Let us not grow weary of doing good, for in due season we will reap.', ref: 'Gal 6:9' },
      { text: 'But you, LORD, are a shield around me, my glory, the one who lifts my head high.', ref: 'Ps 3:3' },
      { text: 'Ask, and it will be given to you; seek, and you will find; knock, and it will be opened to you.', ref: 'Matt 7:7' },
      { text: 'I praise you, for I am fearfully and wonderfully made.', ref: 'Ps 139:14' },
      { text: 'See what great love the Father has given us, that we should be called children of God.', ref: '1 John 3:1' },
      { text: 'By his wounds we are healed.', ref: 'Isa 53:5' },
      { text: 'As the deer pants for streams of water, so my soul pants for you, O God.', ref: 'Ps 42:1' },
      { text: 'I have placed before you an open door that no one can shut.', ref: 'Rev 3:8' },
      { text: 'A man\'s heart plans his way, but the LORD directs his steps.', ref: 'Prov 16:9' },
      { text: 'Be still, and know that I am God.', ref: 'Ps 46:10' },
      { text: 'Do not conform to this world, but be transformed by the renewing of your mind.', ref: 'Rom 12:2' },
      { text: 'You will know the truth, and the truth will set you free.', ref: 'John 8:32' },
      { text: 'Fight the good fight of the faith.', ref: '1 Tim 6:12' },
      { text: 'For I am the LORD your God who takes hold of your right hand.', ref: 'Isa 41:13' },
      { text: 'Do not be anxious about anything, but in everything, by prayer and petition with thanksgiving, present your requests to God.', ref: 'Phil 4:6' },
      { text: 'For you are my hope, O Lord GOD, my trust from my youth.', ref: 'Ps 71:5' },
      { text: 'Comfort, comfort my people, says your God.', ref: 'Isa 40:1' },
      { text: 'He will wipe away every tear from their eyes, and death shall be no more.', ref: 'Rev 21:4' },
      { text: 'When I am afraid, I put my trust in you.', ref: 'Ps 56:3' },
      { text: 'As you received Christ Jesus the Lord, so walk in him.', ref: 'Col 2:6' },
      { text: 'You make known to me the path of life; in your presence there is fullness of joy.', ref: 'Ps 16:11' },
      { text: 'The king\'s heart is a stream of water in the hand of the LORD; he turns it wherever he will.', ref: 'Prov 21:1' },
      { text: 'Praise be to the God of all mercy and the God of all comfort.', ref: '2 Cor 1:3' },
      { text: 'You have set my feet in a spacious place.', ref: 'Ps 31:8' },
      { text: 'God is love, and whoever abides in love abides in God, and God in him.', ref: '1 John 4:16' },
      { text: 'Without faith it is impossible to please God.', ref: 'Heb 11:6' },
      { text: 'Let us hold fast the confession of our hope without wavering.', ref: 'Heb 10:23' },
      { text: 'You are a chosen people, a royal priesthood, a holy nation.', ref: '1 Pet 2:9' },
      { text: 'Great is the LORD and greatly to be praised; his greatness is unsearchable.', ref: 'Ps 145:3' },
      { text: 'We do not have a high priest who is unable to sympathize with our weaknesses.', ref: 'Heb 4:15' },
      { text: 'I know whom I have believed.', ref: '2 Tim 1:12' },
      { text: 'Praise the LORD, all you nations; extol him, all you peoples!', ref: 'Ps 117:1' },
    ];

    // Day-of-year index — same for every visitor on the same date
    var now = new Date();
    var startOfYear = new Date(now.getFullYear(), 0, 0);
    var dayOfYear = Math.floor((now - startOfYear) / 86400000);
    var verse = VERSES[dayOfYear % VERSES.length];

    var textEl = container.querySelector('.verse-of-day__text');
    var refEl = container.querySelector('.verse-of-day__reference');
    var glowEl = container.querySelector('.verse-of-day__glow');

    if (!textEl || !refEl) return;

    textEl.textContent = '„' + verse.text + '“'; // „..."
    refEl.textContent = verse.ref;

    function reveal() {
      // Stagger: glow first, then text, then reference
      if (glowEl) glowEl.classList.add('is-shown');
      setTimeout(function () { textEl.classList.add('is-shown'); }, 120);
      setTimeout(function () { refEl.classList.add('is-shown'); }, 420);
    }

    // If reduced motion: show immediately without transitions (CSS handles it)
    if (reducedMotion) {
      reveal();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          reveal();
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(container);
  }


  /* ═══════════════════════════════════════════════════════════
     5. CUSTOM CURSOR (Desktop / pointer: fine only)
     - Outer ring follows with lerp (lag) for premium feel
     - Inner dot tracks exactly
     - Enlarges on hover over interactive elements
  ═══════════════════════════════════════════════════════════ */

  function initCustomCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (reducedMotion) return;

    var ring = document.createElement('div');
    ring.className = 'ev-cursor is-hidden';
    ring.innerHTML = '<div class="ev-cursor__ring"></div>';
    var dot = document.createElement('div');
    dot.className = 'ev-cursor__dot is-hidden';
    document.body.appendChild(ring);
    document.body.appendChild(dot);

    var LERP = 0.38;
    var STOP_THRESHOLD = 0.15; /* px — rAF stoppt wenn Ring nah genug am Ziel */
    var mx = -100, my = -100;
    var rx = -100, ry = -100;
    var visible = false;
    var rafId = null;

    var INTERACTIVE = 'a, button, [role="button"], input, select, textarea, label, summary, [data-magnetic], .product-grid__card, .collection-card';

    function tick() {
      rx += (mx - rx) * LERP;
      ry += (my - ry) * LERP;
      ring.style.transform = 'translate(' + (rx - 14).toFixed(1) + 'px, ' + (ry - 14).toFixed(1) + 'px)';

      /* Stoppe rAF sobald Ring am Ziel ist — kein permanenter Loop */
      if (Math.abs(mx - rx) < STOP_THRESHOLD && Math.abs(my - ry) < STOP_THRESHOLD) {
        rafId = null;
        return;
      }
      rafId = requestAnimationFrame(tick);
    }

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      /* Dot folgt sofort — kein Lag */
      dot.style.transform = 'translate(' + (mx - 2.5) + 'px, ' + (my - 2.5) + 'px)';
      /* rAF nur starten wenn nicht schon läuft */
      if (!rafId) rafId = requestAnimationFrame(tick);

      if (!visible) {
        ring.classList.remove('is-hidden');
        dot.classList.remove('is-hidden');
        visible = true;
      }

      ring.classList.toggle('is-hovering', !!(e.target && e.target.closest(INTERACTIVE)));
    });

    document.addEventListener('mouseleave', function () {
      ring.classList.add('is-hidden');
      dot.classList.add('is-hidden');
      visible = false;
    });

    document.addEventListener('mouseenter', function () {
      ring.classList.remove('is-hidden');
      dot.classList.remove('is-hidden');
      visible = true;
    });

    document.addEventListener('mousedown', function () {
      ring.classList.add('is-clicking');
      dot.classList.add('is-clicking');
    });
    document.addEventListener('mouseup', function () {
      ring.classList.remove('is-clicking');
      dot.classList.remove('is-clicking');
    });
  }


  /* ═══════════════════════════════════════════════════════════
     6. CHAR REVEAL — Statement Wall Buchstaben-für-Buchstaben
     Splitet [data-char-reveal] Elemente in .ev-char-span Spans.
     IntersectionObserver triggert .is-visible mit gestaffeltem Delay.
  ═══════════════════════════════════════════════════════════ */

  function initCharReveal() {
    var SELECTOR = '[data-char-reveal]';
    var CHAR_DELAY = 0.032; /* Sekunden zwischen Zeichen */
    var CHAR_DELAY_MOBILE = 0.022;
    var isMobile = window.innerWidth < 750;
    var delay = isMobile ? CHAR_DELAY_MOBILE : CHAR_DELAY;

    function splitChars(el) {
      if (el.querySelector('.ev-char-span')) return; /* Guard: bereits gesplitet */

      var raw = el.textContent.trim();
      var offset = 0; /* globaler Delay-Offset für mehrzeilige Elemente */

      /* Prüfe ob Geschwister auch char-reveal haben — dann Offset weiterführen */
      var siblings = el.parentElement
        ? Array.prototype.slice.call(el.parentElement.querySelectorAll('[data-char-reveal]'))
        : [];
      var myIndex = siblings.indexOf(el);
      for (var s = 0; s < myIndex; s++) {
        offset += siblings[s].textContent.trim().replace(/\s+/g, '').length * delay + 0.1;
      }

      var html = '';
      var charCount = 0;
      for (var i = 0; i < raw.length; i++) {
        var ch = raw[i];
        if (ch === ' ') {
          html += '<span class="ev-char-span ev-char-span--space" aria-hidden="true"> </span>';
        } else {
          var d = (offset + charCount * delay).toFixed(3);
          html += '<span class="ev-char-span" style="--char-delay:' + d + 's" aria-hidden="true">' + ch + '</span>';
          charCount++;
        }
      }

      el.innerHTML = html;
      el.setAttribute('aria-label', raw); /* Screenreader liest Original */
    }

    function revealEl(el) {
      el.querySelectorAll('.ev-char-span:not(.ev-char-span--space)').forEach(function (span) {
        span.classList.add('is-visible');
      });
    }

    function observe() {
      var els = document.querySelectorAll(SELECTOR);
      if (!els.length) return;

      if (reducedMotion) {
        els.forEach(function (el) { el.style.opacity = '1'; });
        return;
      }

      els.forEach(splitChars);

      if (!('IntersectionObserver' in window)) {
        els.forEach(revealEl);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealEl(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -60px 0px', threshold: 0.15 }
      );

      els.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  }


  /* ═══════════════════════════════════════════════════════════
     7. COLLECTION PAGE — body.ev-is-collection + Stagger-Upgrade
     Setzt Klasse für CSS-Collection-Header-Targeting.
     Gibt Produktkarten auf Kollektionsseiten stärkere
     Page-Load-Delays (sichtbare Karten staggern beim Laden).
  ═══════════════════════════════════════════════════════════ */

  function initCollectionPage() {
    /* Nur auf Kollektionsseiten aktiv */
    var isCollection = window.location.pathname.indexOf('/collections/') !== -1
      && window.location.pathname.indexOf('/products/') === -1;
    if (!isCollection) return;

    document.body.classList.add('ev-is-collection');

    if (reducedMotion) return;

    /* Warte auf DOMContentLoaded, dann setze stärkere Stagger-Delays
       auf die ersten 12 Produktkarten, die beim Laden direkt sichtbar sind */
    function applyCollectionStagger() {
      var cards = document.querySelectorAll('.product-grid__card, .product-grid__item');
      var vh = window.innerHeight;

      cards.forEach(function (card, i) {
        /* Nur Karten die beim Laden oberhalb des Folds liegen */
        var rect = card.getBoundingClientRect();
        if (rect.top < vh && i < 12) {
          var baseDelay = (i * 0.075).toFixed(3);
          card.style.setProperty('--animate-delay', baseDelay + 's');
          card.setAttribute('data-animate-dir', 'product');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyCollectionStagger);
    } else {
      applyCollectionStagger();
    }
  }


  /* ═══════════════════════════════════════════════════════════
     8. DIVINE PARTICLES — Generative Lichtpartikel im Vers-Moment
     Canvas-basiert, schwebende Goldpartikel steigen auf.
     „EVRLIGHT" = Ever Light — das ist das visuelle Manifest.
     Performance: IntersectionObserver pausiert rAF wenn off-screen.
     prefers-reduced-motion: kein Canvas wird eingefügt.
  ═══════════════════════════════════════════════════════════ */

  function initDivineParticles() {
    if (reducedMotion) return;

    var container = document.getElementById('verse-of-day');
    if (!container) return;

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = [
      'position:absolute',
      'inset:0',
      'width:100%',
      'height:100%',
      'pointer-events:none',
      'z-index:0',
      'display:block',
    ].join(';');

    /* Canvas vor allen anderen Kindern einfügen */
    container.insertBefore(canvas, container.firstChild);

    var ctx = canvas.getContext('2d');
    var particles = [];
    var PARTICLE_COUNT = 28; /* reduziert von 48 — ausreichend für den Effekt */
    var rafId = null;
    var isVisible = false;

    /* Partikel-Fabrik */
    function createParticle(randomY) {
      var size = 0.7 + Math.random() * 1.6;
      return {
        x:        Math.random() * (canvas.width || 400),
        y:        randomY !== undefined ? randomY : (canvas.height || 400) * (0.2 + Math.random() * 0.8),
        vx:       (Math.random() - 0.5) * 0.25,
        vy:       -(0.18 + Math.random() * 0.42),  /* aufwärts */
        size:     size,
        maxAlpha: 0.12 + Math.random() * 0.38,
        /* Jedes Partikel hat eine eigene Atemphase */
        phase:    Math.random() * Math.PI * 2,
        speed:    0.007 + Math.random() * 0.011,
        waveAmp:  0.1 + Math.random() * 0.2,       /* horizontales Wabern */
      };
    }

    function initParticles() {
      canvas.width  = container.offsetWidth;
      canvas.height = container.offsetHeight;
      particles = [];
      for (var i = 0; i < PARTICLE_COUNT; i++) {
        /* Initiale y-Position über die gesamte Höhe verteilt */
        var y = Math.random() * canvas.height;
        particles.push(createParticle(y));
      }
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var w = canvas.width;
      var h = canvas.height;

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];

        p.phase += p.speed;
        var alpha = Math.max(0, Math.sin(p.phase) * p.maxAlpha);

        p.x += p.vx + Math.sin(p.phase * 0.6) * p.waveAmp;
        p.y += p.vy;

        if (p.y < -6) {
          particles[i] = createParticle(h + 4);
          continue;
        }
        if (p.x < -6)    p.x = w + 4;
        if (p.x > w + 6) p.x = -4;

        if (alpha < 0.005) continue;

        /* shadowBlur statt createRadialGradient — kein GC-Druck, gleicher Glow-Effekt */
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.shadowBlur = p.size * 10;
        ctx.shadowColor = 'rgb(201,166,128)';
        ctx.fillStyle = 'rgb(212,184,150)';
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }

      if (isVisible) {
        rafId = requestAnimationFrame(draw);
      } else {
        rafId = null;
      }
    }

    /* IntersectionObserver: nur animieren wenn sichtbar */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        isVisible = entries[0].isIntersecting;
        if (isVisible && !rafId) {
          rafId = requestAnimationFrame(draw);
        }
      }, { threshold: 0.05 });
      io.observe(container);
    } else {
      /* Kein IO-Support → immer animieren */
      isVisible = true;
    }

    initParticles();

    /* ResizeObserver statt window.resize → kein offsetWidth-Read im draw()-Loop */
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { initParticles(); }).observe(container);
    } else {
      window.addEventListener('resize', initParticles, { passive: true });
    }
  }


  /* ═══════════════════════════════════════════════════════════
     7. PARALLAX — media-with-content Bild scrollt langsamer
     Nur Desktop (> 749px), nur transform (GPU-composited).
     rAF mit ticking-Flag — kein doppeltes Frame-Request.
  ═══════════════════════════════════════════════════════════ */

  function initParallax() {
    if (reducedMotion) return;
    if (window.innerWidth < 750) return;

    var SELECTOR = '.media-with-content__media';
    var STRENGTH = 0.35;
    /* Cache: { el, centerPageY, halfH } — wird bei collect() berechnet, nicht pro Frame */
    var items = [];
    var ticking = false;

    function collect() {
      /* Lese Layout einmalig — kein getBoundingClientRect im Scroll-Handler */
      items = Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).map(function (el) {
        var rect = el.getBoundingClientRect();
        var pageY = rect.top + window.scrollY; /* absolute Y-Position auf der Seite */
        return { el: el, centerPageY: pageY + rect.height * 0.5, halfH: rect.height * 0.5 };
      });
    }

    function update() {
      var scrollY = window.scrollY;
      var vh = window.innerHeight;

      items.forEach(function (item) {
        /* Viewport-Zentrum relativ zum Element berechnen — reine Arithmetik, kein Layout-Read */
        var viewCenterY = scrollY + vh * 0.5;
        var progress = (viewCenterY - item.centerPageY) / vh;

        /* Sichtbarkeits-Check ohne getBoundingClientRect */
        var topOnScreen = item.centerPageY - item.halfH - scrollY;
        if (topOnScreen > vh * 1.5 || topOnScreen < -vh * 1.5) return;

        var offset = (progress * vh * STRENGTH).toFixed(2);
        item.el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    collect();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });

    /* will-change nur während Scroll-Interaktion, danach freigeben */
    var scrollEndTimer = null;
    window.addEventListener('scroll', function () {
      items.forEach(function (item) { item.el.style.willChange = 'transform'; });
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(function () {
        items.forEach(function (item) { item.el.style.willChange = 'auto'; });
      }, 200);
    }, { passive: true });

    /* Bei Resize Positionen neu berechnen */
    window.addEventListener('resize', function () {
      collect();
      update();
    }, { passive: true });

    document.addEventListener('shopify:section:load', function () {
      collect();
      update();
    });
  }


  /* ═══════════════════════════════════════════════════════════
     7. MARQUEE SKEW — Scroll-Velocity-Tilt auf dem Marquee
     Nur Desktop mit feinem Pointer.
     Lerp auf currentSkew → weiche Rückkehr zu 0.
  ═══════════════════════════════════════════════════════════ */

  function initMarqueeSkew() {
    if (reducedMotion) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var SELECTOR = '.marquee, marquee-component';
    var MAX_SKEW = 2.5;   /* Grad */
    var VELOCITY_FACTOR = 0.018;
    var LERP_FACTOR = 0.12;

    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!els.length) return;

    var lastScrollY = window.scrollY;
    var currentSkew = 0;
    var targetSkew = 0;
    var rafId = null;

    function tick() {
      currentSkew += (targetSkew - currentSkew) * LERP_FACTOR;
      var skewStr = 'skewX(' + currentSkew.toFixed(3) + 'deg)';
      els.forEach(function (el) {
        el.style.transform = skewStr;
      });

      /* Weiterlaufen bis fast null */
      if (Math.abs(currentSkew) > 0.01 || Math.abs(targetSkew) > 0.01) {
        rafId = requestAnimationFrame(tick);
      } else {
        els.forEach(function (el) { el.style.transform = ''; });
        rafId = null;
      }
    }

    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      var velocity = scrollY - lastScrollY;
      lastScrollY = scrollY;

      targetSkew = Math.max(-MAX_SKEW, Math.min(MAX_SKEW, velocity * VELOCITY_FACTOR));

      if (!rafId) rafId = requestAnimationFrame(tick);
    }, { passive: true });
  }


  /* ═══════════════════════════════════════════════════════════
     BOOTSTRAP — run everything
  ═══════════════════════════════════════════════════════════ */

  function boot() {
    initScrollFade();
    initMagneticButtons();
    initTextReveal();
    initVerseOfDay();
    initCharReveal();
    initCollectionPage();
    initDivineParticles();
    initParallax();
    initMarqueeSkew();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Cursor nach allen anderen Overlays ins DOM einfügen,
     damit es im Paint-Order garantiert ganz oben liegt. */
  window.addEventListener('load', initCustomCursor);

})();